import { type NotificationConfigProps } from "@snapchat/snap-design-system";

import { globalNotificationStyle } from "../styles";

const commonNotification: Partial<NotificationConfigProps> = {
    className: globalNotificationStyle,
    autoDismiss: true,
};

export const changesHaveBeenMade: NotificationConfigProps = {
    title: "Changes have been made",
    message: "Save changes to update",
    key: "1",
    ...commonNotification,
};

export const idIsCopiedToClipboard: NotificationConfigProps = {
    title: "Lens Group ID copied to clipboard",
    className: globalNotificationStyle,
    key: "2",
    ...commonNotification,
};

export const allChangesHaveBeenSaved: NotificationConfigProps = {
    title: "All changes have been saved",
    className: globalNotificationStyle,
    key: "3",
    ...commonNotification,
};

export const lensDetailsError = (title: string): NotificationConfigProps => ({
    title,
    className: globalNotificationStyle,
    key: "lens-details-error",
    ...commonNotification,
});

export const lensGroupSuccessfullyDeleted: NotificationConfigProps = {
    title: "Lens Group successfully deleted.",
    key: "4",
    ...commonNotification,
};

export const lensIdIsCopiedToClipboard: NotificationConfigProps = {
    title: "Lens ID copied to clipboard",
    className: globalNotificationStyle,
    key: "5",
    ...commonNotification,
};

export const lensGroupIdIsCopiedToClipboard: NotificationConfigProps = {
    title: "Lens Group ID copied to clipboard",
    className: globalNotificationStyle,
    key: "6",
    ...commonNotification,
};

export const onboardingTokenIsConsumed: NotificationConfigProps = {
    title: "You were redirected to this page because the token is expired",
    className: globalNotificationStyle,
    key: "7",
    ...commonNotification,
};

// Used to display errors on groupDetails operations
export const groupDetailsError = (title: string, key: number): NotificationConfigProps => ({
    title,
    className: globalNotificationStyle,
    key: `${8 + key}`, // key < 11
    ...commonNotification,
});
